<div class="flex flex-col h-full w-full bg-white">
  <!-- Header -->
  <app-page-header>
    <div class="flex items-center justify-between flex-1 min-w-0">
      <div class="flex items-center gap-3 flex-1 min-w-0">
        <button (click)="goBack()" class="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-gray-100">
          <fa-icon [icon]="faChevronLeft" class="text-sm text-gray-500"></fa-icon>
        </button>
        <span class="text-xl font-medium text-gray-900 truncate">{{ checkName || 'Prüfung' }}</span>
      </div>
      @if (reportId && isLogRoute) {
<bic-button (click)="onViewReport()" buttonType="white">Bericht
        <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
      </bic-button>
}
    </div>
  </app-page-header>

  <!-- Step content fills remaining space -->
  <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
    @switch (currentView) {
      @case ('init') {
        <!-- Neutraler Initialzustand beim Laden der Definition (kein Ladebalken-Screen) -->
        <div class="flex flex-1 items-center justify-center">
          <fa-icon [icon]="faSpinnerThird" class="animate-spin text-green text-[32px]"></fa-icon>
        </div>
      }
      @case ('selection') {
        @if (selectionPlan && !isLogRoute) {
          <my-checks-step-combined-select
            (cancelled)="onCancel()"
            (started)="onStartCheck($event)"
            [plan]="selectionPlan"
            [projectId]="projectId"/>
        } @else if (isLogRoute) {
          <my-checks-step-log
            (detailClosed)="onLogDetailClosed()"
            (detailRequested)="onLogDetailRequested($event)"
            [activeDetail]="activeLogDetail"
            [durations]="checkDurations"
            [logs]="progressLogs"
            [progress]="progressInfo"
            [selectedFiles]="selectedFilesData"
            [selectedRules]="selectedRulesData"
            [statusMessage]="loadingMessage"
            [steps]="progressSteps"/>
        }
      }
      @case ('interactive') {
        <ng-container *ngComponentOutlet="activeInteractionComponent; inputs: activeInteractionInputs"/>
      }
      @case ('loading') {
        @if (isLogRoute) {
          <my-checks-step-log
            (detailClosed)="onLogDetailClosed()"
            (detailRequested)="onLogDetailRequested($event)"
            [activeDetail]="activeLogDetail"
            [durations]="checkDurations"
            [logs]="progressLogs"
            [progress]="progressInfo"
            [selectedFiles]="selectedFilesData"
            [selectedRules]="selectedRulesData"
            [statusMessage]="loadingMessage"
            [steps]="progressSteps"/>
        } @else {
          <my-checks-step-processing
            [logs]="progressLogs"
            [progress]="progressInfo"
            [selectedFiles]="selectedFilesData"
            [selectedRules]="selectedRulesData"
            [statusMessage]="loadingMessage"
            [steps]="progressSteps"/>
        }
      }
      @case ('failed') {
        <my-checks-error
          (close)="onClose()"
          (retry)="onRetry()"
          (viewLogs)="onViewLogs()"
          [canViewLogs]="!!instanceId"
          [details]="errorDetails"
          [error]="errorMessage"/>
      }
    }
  </div>
</div>
